<template>
<div class="fc-page mg-page"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>添加文章</h1><p>完善文章信息与正文内容，发布机构资讯</p></div></header><div class="mg-article-layout"><section class="fc-records mg-article-meta"><div class="fc-list-heading"><h3>文章信息</h3></div><div class="mg-section-body"><v-select :items="selectColList" v-model="add.article.colId"
						item-text="colName" item-value="id" label="栏目" dense outlined color="#d9363e" aria-label="栏目"></v-select><v-text-field label="标题" v-model="add.article.caption" dense outlined color="#d9363e" aria-label="标题"></v-text-field><v-file-input @change="fileSelected" label="封面图" v-model="upload.files" :rules="upload.rules"
							placeholder="请选择图片" accept="image/png, image/jpeg" dense
							outlined show-size small-chips color="#d9363e" aria-label="封面图" /><div class="mg-cover-preview"><v-progress-circular v-if="upload.percent > 0 " color="primary" size="40" width="2"
							v-model="upload.percent">
							{{ upload.percent }}%
						</v-progress-circular><v-img v-if="upload.key" class="ml-2" :src="imgPrev + upload.key" :aspect-ratio="15/4" width="100%" ></v-img></div><p class="mg-help">正文与封面将用于文章展示</p></div></section><section class="fc-records mg-article-editor"><div class="fc-list-heading"><h3>文章正文</h3></div><div class="mg-editor"><Toolbar
								style="border-bottom: 1px solid #e3e9f0;"
								:editor="editor"
								:defaultConfig="toolbarConfig"
								:mode="mode"
							/><Editor
								style="height: 500px; overflow-y: hidden;"
								v-model="add.article.content"
								:defaultConfig="editorConfig"
								:mode="mode"
								@onCreated="onCreated"
								@onChange="onChange"
							/></div></section></div><div class="mg-editor-footer"><v-btn color="#d9363e" @click="submitAdd" depressed class="mg-create">
					提交
				</v-btn></div></div>
</template>

<script>
	import * as qiniu from 'qiniu-js'
	import moment from 'moment'
	import global from '../../../config/global'
	import storage from "../../../config/storage"
	import {
		Editor,
		Toolbar
	} from '@wangeditor/editor-for-vue'
	export default {
		name: "article-list",
		components: {
			Editor,
			Toolbar
		},
		data() {
			return {
				editor: null,
				
				toolbarConfig: {
					excludeKeys: [ 'uploadVideo','uploadImage'],
				},
				editorConfig: {
					placeholder: '请输入内容...'
				},
				mode: 'default', // or 'simple'
				imgPrev: global.config.imgPre,
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '文章列表',
						disabled: false,
						href: "/content/article/list"
					},
					{
						text: '添加文章',
						disabled: true
					},
				],
				selectColList:[], //选择栏目数据源
				add: {
					article: {
						caption: "",
						colId:"",
						content:"",
						coverImg:""
					},
				},
				upload: {
					rules: [
						value => !value || value.size < 4000000 || '图片大小不能超过4M!',
					],
					files: null, // 多选文件用[]
					pre: "assets/img/",
					mid: "",
					percent: 0,
					key: "" // 全路径
				},
				// 上传的监视事件
				observe: {
					next: this.onNext,
					error: this.onError,
					complete: this.onComplete
				},
			}
		},
		created() {
			// 获取门店列表
			this.getColListForSelect();
		},
		methods: {
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
				//const keys = this.editor.getAllMenuKeys();
				//console.log(keys);
			},
			onChange(editor) { console.log('onChange', editor.getHtml()) },
			getColListForSelect(){
				const that = this;
				let url = `/content/col/list`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectColList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			fileSelected(file) {
				this.uploadFile(file);
			},
			onNext(res) {
				this.upload.percent = res.total.percent.toFixed();
			},
			onComplete(res) {
				console.log(res);
				// 上传完成 显示缩略图
				this.upload.key = res.key;
				
			},
			onError(err) {
				this.$noty.error("上传失败：" + err.message);
			},
			uploadFile(file) {
				const that = this;
			
				if (file) {
					const indexOfSuffix = file.name.lastIndexOf(".");
					//文件后缀
					const suffix = indexOfSuffix >= 0 ? file.name.substr(indexOfSuffix) : "";
					// 上传的文件名
					const filename = "op_" + moment().unix() + suffix;
					// 上传的key
					const key = this.upload.pre + this.upload.mid + filename;
					//const url = this.upload.picture.defaultPre + key;
			
					let uploadToken = storage.getUploadImgToken();
					if (!uploadToken) {
						this.$noty.error("上传失败,上传凭证已失效，请联系管理员");
						return;
					}
			
					
					const putExtra = {
						fname: "",
						params: {},
						mimeType: null
					};
					const config = {
						useCdnDomain: true,
						region: qiniu["region"].z2
					};
					let observable = qiniu["upload"](file, key, uploadToken, putExtra, config);
					observable.subscribe(this.observe);
				}
			},
			submitAdd() {
			
				if (!this.add.article.caption) {
					this.$noty.error('标题名称不能为空');
					return
				}
				
				if (!this.add.article.colId) {
					this.$noty.error('栏目不能为空');
					return
				}

				// api
				const that = this;
				let url = `/content/article/create`;
				let postData = {...this.add.article};
				if(this.upload.key){
					postData.coverImg = this.upload.key;
				}
				
				console.log(postData);
			
			
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							
							setTimeout(()=>{
								that.$router.push("/content/article/list");
							},500)
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
			
				});
			
			},
		},
		beforeDestroy() {
			const editor = this.editor
			if (editor == null) return
			editor.destroy() // 组件销毁时，及时销毁编辑器
		}
	}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
